import React, { createContext, useContext, useMemo } from 'react';
import CustomModal from './index.jsx';
import { useModal } from './useModal';

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const modal = useModal();

  const contextValue = useMemo(() => ({
    ...modal
  }), [modal]);

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <CustomModal
        isOpen={modal.modalState.isOpen}
        onClose={modal.hideModal}
        type={modal.modalState.type}
        title={modal.modalState.title}
        message={modal.modalState.message}
        confirmText={modal.modalState.confirmText}
        onConfirm={modal.modalState.onConfirm}
        showCancel={modal.modalState.showCancel}
        cancelText={modal.modalState.cancelText}
        onCancel={modal.modalState.onCancel}
        inputType={modal.modalState.inputType}
        inputValue={modal.modalState.inputValue}
        onInputChange={modal.modalState.onInputChange}
      />
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) {
    throw new Error('useModalContext deve ser usado dentro de ModalProvider');
  }
  return ctx;
};

export default ModalProvider;


